import { render, staticRenderFns } from "./pamphlet_modal_btn.vue?vue&type=template&id=26a34cee&"
import script from "./pamphlet_modal_btn.vue?vue&type=script&lang=js&"
export * from "./pamphlet_modal_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports